<template class="">
  <div class="main_">
		
    <div class="header_">
			
      <div class="bg_header_">
		<div class="" style="text-align: left; width: 100px; height: 30px; position: absolute; top: 0px; left: 20px;"  >
		  <div class="" style="color: white;"> 
		   <router-link to="/index"> 
		   <el-image style="width: 80px; height:28px" :src="headPhoto"></el-image>
		    </router-link>
		   </div>
		</div>
        <div class="header__nav fl t_title_">{{tbtext}} </div>
			<div class="" style="text-align: right; width: 150px; height: 40px; position:absolute; right: 20px; top: 0px;"  >
				<div>
					<span style="color: white; display: inline-block;font-size: 13px"  class="dates_02"></span>
					<span class="fullScreen" @click="fullScreen" style=" display: inline-block; text-align: right; color: #FFFFFF; font-size: 13px">
						  <el-tooltip class="item" effect="dark" content="全屏" placement="bottom">
							<i class="fa fa-arrows-alt fa-lg"></i>
						  </el-tooltip>
					</span>
					<div style="color: white; font-size: 13px;"  class="dates_01"></div>
				</div>
			 
			</div>
		
      </div>
    </div>

    <div class="data_content_">
      <div class="data_time">
        <!-- <router-link to="/data"><span>刷新提示：</span></router-link>跳转至视频监控》-->
      </div>
      <div class="data_main">
       <div class="main_center fl">
          <div class="center_text">
          
            <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div>
           
            <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div>
           
            <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div>
          
            <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div>
            <div class="main_title" style="padding-left:48px;">
              视频展示
            </div>
            <!-- <div id="container" style="width:100%;height:610px;"></div>-->
            <div id="barChart6" style="width:100%;height:290px;">
				
				<video-player class="video-player_ vjs-custom-skin"  
				  ref="videoPlayer" 
				  :playsinline="true" 
				  :options="playerOptions"
				   @ended="onPlayerEnded">
				  
				</video-player>
				
		
				
			</div>
          </div>
        </div>
		<div class="main_right fr" style="height: 290px;">
		   
	
		<div class="right_1"  style="height: 290px;">
		    <!--左上边框-->
		    <div class="t_line_box">
		      <i class="t_l_line"></i>
		      <i class="l_t_line"></i>
		    </div>
		    <!--右上边框-->
		    <div class="t_line_box">
		      <i class="t_r_line"></i>
		      <i class="r_t_line"></i>
		    </div>
		    <!--左下边框-->
		    <div class="t_line_box">
		      <i class="l_b_line"></i>
		      <i class="b_l_line"></i>
		    </div>
		    <!--右下边框-->
		    <div class="t_line_box">
		      <i class="r_b_line"></i>
		      <i class="b_r_line"></i>
		    </div>
		    <div class="main_title" style=" padding-left:48px;">
		      <!--   <img src="img/t_4.png" alt="">-->
		      图片展示
		    </div>
		    <div id="barChart3" class="echart t_btn7" style="width:100%;height:280px; ">
			
			  <el-carousel :interval="4000" type="" height="280px" >
				  <el-carousel-item v-for="item in imgArray" :key="item.id">
					<img :src="item.headPhoto" class="image_">
				  </el-carousel-item>
				</el-carousel>
			
				
			</div>
		  </div>
		 	</div>
		</div>
		
	<div class="data_bottom_" style=" height: 190px">
	  <div class="bottom_1 fl t_btn5" style="cursor: pointer;">
		<!--左上边框-->
		<div class="t_line_box">
		  <i class="t_l_line"></i>
		  <i class="l_t_line"></i>
		</div>
		<!--右上边框-->
		<div class="t_line_box">
		  <i class="t_r_line"></i>
		  <i class="r_t_line"></i>
		</div>
		<!--左下边框-->
		<div class="t_line_box">
		  <i class="l_b_line"></i>
		  <i class="b_l_line"></i>
		</div>
		<!--右下边框-->
		<div class="t_line_box">
		  <i class="r_b_line"></i>
		  <i class="b_r_line"></i>
		</div>
					
		  <div class="main_title" style=" padding-left: 10px;  " v-if="hide1" >
						
		    <!--  <img src="img/t_5.png" alt="">-->
		    今日演出表
		  </div>
		<div class="main_title" style=" padding-left: 10px; color: #33FFFF;" v-if="hide2">
		  <!--  <img src="img/t_5.png" alt="">-->
		  明日演出表
		</div>
		 <div id="main_table_" class="echart fl" style="width:100%;height: 180px;font-size: 14px;color: #FFFFFF;text-align: center;">
					
		   <el-table
			  v-if="hide1"
		      :data="tableData"
		       style=" font-size: 12px;color: #FFFFFF; background: #0c1e32;"
		   	 height="180"
			 id="datatxet_centaz"
		   	:row-style=" {height:'0',background:'#0c1e32',font:'12px'}"  
		   	:header-row-style=" {background:'#0c1e32',} " 
		      :header-cell-style="thStyleFun"
		       :cell-style="cellStyleFun"
		  >
		  <el-table-column label="节目名称" width="">
		      <template slot-scope="scope">
		        <span>{{ scope.row.programName}}</span>
		      </template>
						
		    </el-table-column>
		     <el-table-column label="开始时间段" width="">
		      <template slot-scope="scope">
		        <span>{{ scope.row.startPeriod}}-{{ scope.row.endPeriod}}</span>
		      </template>
		    </el-table-column>
		    <el-table-column label="演出说明" width="">
		      <template slot-scope="scope">
		        <span>{{ scope.row.remark }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column label="演出地址" width="">
		      <template slot-scope="scope">
		        <span>{{ scope.row.programAddress }}</span>
		      </template>
		    </el-table-column>
		 </el-table> 
				<el-table
					   v-if="hide2"
					    :data="tableData_"
					     style=" font-size: 12px;color: #FFFFFF; background: #0c1e32;"
					 	 height="180"
						 id="datatxet_centaz"
					 	:row-style=" {height:'0',background:'#0c1e32',font:'12px'}"  
					 	:header-row-style=" {background:'#0c1e32',} " 
					    :header-cell-style="thStyleFun"
					     :cell-style="cellStyleFun"
					>
					<el-table-column label="节目名称" width="">
					    <template slot-scope="scope">
					      <span>{{ scope.row.programName}}</span>
					    </template>
						
					  </el-table-column>
					   <el-table-column label="开始时间段" width="">
					    <template slot-scope="scope">
					      <span>{{ scope.row.startPeriod}}-{{ scope.row.endPeriod}}</span>
					    </template>
					  </el-table-column>
					           
					   <el-table-column label="演出说明" width="">
					    <template slot-scope="scope">
					      <span>{{ scope.row.remark }}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="演出地址" width="">
					    <template slot-scope="scope">
					      <span>{{ scope.row.programAddress }}</span>
					    </template>
					  </el-table-column>
					
					</el-table> 
		 </div>
		</div>
		</div>
       <!-- <div class="main_right fr" style="height: 150px;">
         
      </div> -->
      <div class="data_bottom_" style=" height:40px;margin-top:5px;">
        <div class="bottom_2 fl t_btn5" style="cursor: pointer;">
          <!--左上边框-->
          <div class="t_line_box">
            <i class="t_l_line"></i>
            <i class="l_t_line"></i>
          </div>
          <!--右上边框-->
          <div class="t_line_box">
            <i class="t_r_line"></i>
            <i class="r_t_line"></i>
          </div>
          <!--左下边框-->
          <div class="t_line_box">
            <i class="l_b_line"></i>
            <i class="b_l_line"></i>
          </div>
          <!--右下边框-->
          <div class="t_line_box">
            <i class="r_b_line"></i>
            <i class="b_r_line"></i>
          </div>
         <!-- <div class="main_title" style=" padding-left: 55px;">
            
            通告信息展示
          </div> -->
          <div id="barChart5" class="echart fl" style="width:100%; height: 40px;font-size: 14px;color: #FFFFFF;text-align: center;">
			  
	        <span style=" margin-top: 0px;display: inline-block;">
				
				<marquee width=1000 bhavior=alternate direction=left align=middle> {{dbtext}}</marquee>
			</span> 
		  </div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {

  name: "dataList",
  data() {
    return { 
		hide1:true,
		hide2:false,
		buttonName: '',
		time: 1,
		tableData:[], 
		tableData_:[], 
		tbtext: '',
	    headPhoto: '',
		dbtext: '',
		imgArray:[],
		flag: 0, // 记录播放位置
		videos: [], // 视频列表
		      // 播放器相关配置
		playerOptions: {
		playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
		autoplay: true, // 如果为true,浏览器准备好时开始回放。
		muted: false, // 默认情况下将会消除任何音频。
		loop: false, // 是否视频一结束就重新开始。
		preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
		language: 'zh-CN',
		aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
		fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
		sources: [
			{ type: 'video/mp4',
			 src:  '' },
			], // 因为我们要动态加载，所以src默认为空
		poster: '', // 封面地址
		notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
		controlBar: {
		  timeDivider: true, // 当前时间和持续时间的分隔符
		  durationDisplay: true, // 显示持续时间
		  remainingTimeDisplay: false, // 是否显示剩余时间功能
		  fullscreenToggle: true // 是否显示全屏按钮
			}
		  },
		
	};
  },
  components: {},
  mounted() {
	this.sendMsg()
	this.initDate();
    this.getData1();
	this.getData2();
	this.getData3();
	this.getData4();
	this.getData5();
	this.getData6();
	 this.initSetTimeout();
  },
  beforeDestroy(){
	  clearInterval(this.timer);　　// 清除定时器
	  this.timer = null;
	},
  methods: {
	  initSetTimeout() {
	   this.timer= setInterval(() => {
		   
	     this.checkIsUpdate()
		 this.getData4();
		 this.getData5();
		 this.getData6();
	    }, 60000);
	  },
	checkIsUpdate(){
		let storage = window.sessionStorage;
		let accountID = storage.getItem("userId");
		let scenicAreaID = storage.getItem("companyId");
	    this.$axios({
				url: "/api/infoPublish_element/checkIsUpdate",
				method: "get",
				params: {
					scenicAreaID: scenicAreaID,
				}
			})
			.then(res => {
			 var data = res.data;
				console.log(data)
		
		   
			})
			.catch(err => {
			console.log(err);
		});
		},
	 sendMsg() {
		let this_ = this;
		let interval = window.setInterval(function() {
			this_.hide1=true;
			this_.hide2=false;
		      this_.buttonName = this_.time
			  --this_.time;
			 
			 if(this_.time <0) {
				this_.time=1;
				this_.hide1=false;
				this_.hide2=true;
			}
		  }, 15000);

	    },
	   getVideos () {
		  //this.videos = ['https://www.runoob.com/try/demo_source/mov_bbb.mp4', 'https://www.runoob.com/try/demo_source/mov_bbb.mp4', 'https://www.runoob.com/try/demo_source/mov_bbb.mp4'] // 从服务器获取视频列表
	       this.playerOptions['sources'][0]['src'] = this.videos[0] // 首先加载第一个
	     },
	 
	     // 视频播完回调
		 onPlayerEnded() {
			 let this_=this;
		   // 下标 +1
		    this.flag += 1
		     console.log(this.flag)
		   // 放完从第一个播放 否则直接播放下一个
		   if (this.flag + 1 > this.videos.length) {
			 this_.flag = 0
			 this_.playerOptions['sources'][0]['src'] = this_.videos[0]
		   } else {
			 this_.playerOptions['sources'][0]['src'] = this_.videos[this_.flag]
			 console.log(this_.playerOptions['sources'][0]['src'])
		   }
		 },
	
	  fullScreen(){
		  
		    if (this.isfullScreen) {
		      var docElm = document.documentElement;
		      if (docElm.requestFullscreen) {
		        docElm.requestFullscreen();
		      } else if (docElm.mozRequestFullScreen) {
		        docElm.mozRequestFullScreen();
		      } else if (docElm.webkitRequestFullScreen) {
		        docElm.webkitRequestFullScreen();
		      } else if (elem.msRequestFullscreen) {
		        elem.msRequestFullscreen();
		      }
		      this.isfullScreen = false;
		    } else {
		      if (document.exitFullscreen) {
		        document.exitFullscreen();
		      } else if (document.mozCancelFullScreen) {
		        document.mozCancelFullScreen();
		      } else if (document.webkitCancelFullScreen) {
		        document.webkitCancelFullScreen();
		      } else if (document.msExitFullscreen) {
		        document.msExitFullscreen();
		      }
		      this.isfullScreen = true;
		    }
		  
	  },
	  initDate() {
	      setInterval(function () {
	        var year, month, sun, day, hour, minute, second
	        var date = new Date();
	        year = date.getFullYear();
	        month = date.getMonth() + 1;
	        sun = date.getDate();
	        day = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六")[date.getDay()];
	        hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
	        minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
	        second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
	        $('.dates_01').html(hour + ':' + minute + ':' + second)
	        $('.dates_02').html(year + '.' + month + '.' + sun + ' ' + day);
	      }, 1000)
	   },

    getData1() {
		 let storage = window.sessionStorage;
				let accountID = storage.getItem("userId");
				let scenicAreaID = storage.getItem("companyId");
				let dataType =2;//图片
				let isEnable='3'
				this.$axios({
						url: "/api/infoPublish_element",
						method: "get",
						params: {
							dataType:dataType,
							pageItems: 999, //每页显示的条数
							pageNumber: 1, //页数
							isEnable:isEnable,
							scenicAreaID: scenicAreaID,
						}
					})
					.then(res => {
						this.imgArray=[];
						 var data = res.data[0];
						   this.tableData = [];
						 console.log(data)
					    for (const i in data) {
						 var headPhoto = "";
						if (data[i].content) {
						   headPhoto = "/api/image?url=" + data[i].content;
						   
						}
						
						this.imgArray.push({
							headPhoto:headPhoto
						});
						console.log(this.imgArray)
				
		        }
					
					})
					.catch(err => {
					console.log(err);
				});
			
      
    },

    getData2() {
   	        let storage = window.sessionStorage;
   			let accountID = storage.getItem("userId");
   			let scenicAreaID = storage.getItem("companyId");
   			let dataType =1;//视频
			let isEnable='3'
   			this.$axios({
   					url: "/api/infoPublish_element",
   					method: "get",
   					params: {
   						dataType:dataType,
   						pageItems: 999, //每页显示的条数
   						pageNumber: 1, //页数
						isEnable:isEnable,
   						scenicAreaID: scenicAreaID,
   					}
   				})
   				.then(res => {
   					this.videos=[];
   					var data = res.data[0];
   				    console.log(data)
   				    for (const i in data) {
   					 var video = "";
   					if (data[i].content) {
   					   video = "/api/image?url=" + data[i].content;
   					   
   					}
   					this.videos.push(video);
   				}
			    this.getVideos();
   				
   				})
   				.catch(err => {
   				console.log(err);
   			});
    },
    getData3(){//LOGO
			let dataType =4;//图片
			let storage = window.sessionStorage;
			let accountID = storage.getItem("userId");
			let scenicAreaID = storage.getItem("companyId");
			
			this.$axios({
					url: "/api/infoPublish_element",
					method: "get",
					params: {
						
						dataType:dataType,
						pageItems: 999, //每页显示的条数
						pageNumber: 1, //页数
						scenicAreaID: scenicAreaID,
						
					}
				})
			.then(res => {
			    var data = res.data[0];
				console.log(data)
				this.headPhoto = "/api/image?url=" + data[0].content;
				
			})
			.catch(err => {
				console.log(err);
			});
	},
	getData4(){//文字
		let storage = window.sessionStorage;
		let accountID = storage.getItem("userId");
		let scenicAreaID = storage.getItem("companyId");
		let dataType =3 ;//通告
		this.$axios({
			url: "/api/infoPublish_element",
			method: "get",
			params: {
				dataType:dataType,
				pageItems: 999, //每页显示的条数
				pageNumber: 1, //页数
				scenicAreaID: scenicAreaID,
				
			}
				})
			.then(res => {
			  var data = res.data[0];
				console.log(data)
				this.dbtext=data[0].remark
				this.tbtext=data[0].content
				
			})
			.catch(err => {
				console.log(err);
			});
	},
	getData5(){ 
		let storage=window.sessionStorage;
		let token = storage.getItem("token")
		let companyID = storage.getItem("companyId")
		let yy = new Date().getFullYear();
		let mm = new Date().getMonth()+1;
		let dd = new Date().getDate();
		let hh = new Date().getHours();
		let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
		let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
		 if(mm >= 1 && mm <= 9) {
			mm = "0" + mm;
			}
		 if (dd >= 0 && dd <= 9) {
			dd = "0" + dd;
			}
		let gettime = yy+'-'+mm+'-'+dd
		console.log(gettime)
		let endTime ="";
		let startTime  ="";
		let programStatus="3";
		let playDate =gettime;
		this.$axios({
		url: "/api/infoPublish_program",
		method: "get",
		params: {
			playDate:playDate,
		  pageItems: 999, //每页显示的条数
		  pageNumber: 1, //页数
		  token: token,
		  programStatus:programStatus,
		  scenicAreaID:companyID,
		
		}
		  })
		    .then(res => {
		    	console.log(res.data)
		    	var data = res.data[0];
		        this.tableData = [];
				for(const i in data) {
					//let start = data[i].startPeriod.substring(0, 2)+':'+data[i].startPeriod.substring(2, 4);
					//let end = data[i].endPeriod.substring(0, 2)+':'+data[i].endPeriod.substring(2, 4);
					 this.tableData.push({
					  programName: data[i].programName,
					  startPeriod:data[i].startPeriod,
					  endPeriod:data[i].endPeriod,
					  playStartTime:data[i].playStartTime,
					  programAddress: data[i].programAddress,
					  remark: data[i].remark,
					  playEndTime:data[i].playEndTime,
					});
				
					
				  }
		     // this.tableDataLength = res.data[1];
		    
		    })
		    .catch(err => {
		      console.log(err);
		    });
		
	},
	getData6(){
		let storage=window.sessionStorage;
		let token = storage.getItem("token")
		let companyID = storage.getItem("companyId")
		var day3 = new Date();
		day3.setTime(day3.getTime()+24*60*60*1000);
		 var gettimeday = day3.getFullYear()+"-" + (day3.getMonth()+1) + "-" + day3.getDate();
		 console.log(gettimeday)
		let programStatus="3";
		let playDate =gettimeday;
		this.$axios({
		url: "/api/infoPublish_program",
		method: "get",
		params: {
		  playDate:playDate,
		  pageItems: 999, //每页显示的条数
		  pageNumber: 1, //页数
		  token: token,
		  programStatus:programStatus,
		  scenicAreaID:companyID,
		  projectID: "1"
		}
		  })
		    .then(res => {
		    	console.log(res.data)
		    	var data = res.data[0];
		    
				 this.tableData_ = [];
					for(const i in data) {
					//let start = data[i].startPeriod.substring(0, 2)+':'+data[i].startPeriod.substring(2, 4);
					//let end = data[i].endPeriod.substring(0, 2)+':'+data[i].endPeriod.substring(2, 4);
				
					this.tableData_.push({
					  programName: data[i].programName,
					  startPeriod:data[i].startPeriod,
					  endPeriod:data[i].endPeriod,
					  playStartTime:data[i].playStartTime,
					  programAddress: data[i].programAddress,
					  remark: data[i].remark,
					  playEndTime:data[i].playEndTime,
					});
					
				  }
		     // this.tableDataLength = res.data[1];
		    
		    })
		    .catch(err => {
		      console.log(err);
		    });
		
	},
	thStyleFun() {
			return "text-align:center;color:#fff;font-size:12px;background-color: #0c1e32; font-family: PingFangSC-Regular, PingFang SC; border-color: #0c1e32 ";
		},
		cellStyleFun() {
			return "text-align:center;font-family: PingFangSC-Regular, PingFang SC;background-color: #0c1e32 ;border-color: #0c1e32;	padding:0; ";
		},
  
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  font-family: PingFangSC-Light, 微软雅黑;
}
.main_ {
  width: 100%;
  height: 100% !important ;
  color: #333;
  /* overflow: hidden;*/
  background: url("../../../../static/true.png") no-repeat;
  background-size: 100% 100%;
}

/*body{
  width: 100%;
  height: 100%;
  background-color: #2d3a4b;
	}*/
.map {
  padding-left: 1%;
  padding-right: 1%;
  width: 98%;
  height: 100%;
}
.map icon {
  width: 20px;
  height: 20px;
}

/*#barChart1{
	width:30vm;
  text-align: center;
  height: 45vh;
  margin-bottom: 10px;
  overflow:hidden;
  
 
}
#barChart2{
  width:30vm;
  text-align: center;
  height: 45vh;
overflow:hidden;

}
#barChart3{
  width:30vm;
  text-align: center;
  height: 45vh;
  overflow:hidden;
  margin-bottom: 10px;
 
}

#barChart4{
  width:30vm;
  text-align: center;
  height: 45vh;
  overflow:hidden;
  
}*/

.amap-wrapper {
  width: 38vm;
  height: 40vh;
  background: #f2dede;
}

 .video-player_{
  padding-left: 1% !important;;
  padding-right: 1% !important;;
  width: 98% !important;;
  height:250px !important;
  margin-top: 5px !important;;
  background-color: rgb(0, 0, 0) !important;;
  }
  .video-js{
	  height: 100%;
	  padding: 0;
	  
  }
 
.video-js .vjs-big-play-button{
	text-align: center;
	
}


/*布局*/

/*各浏览器显示不同，去掉蓝色边框*/
fieldset,
img,
input,
button {
  border: none;
  padding: 0;
  margin: 0;
  outline-style: none;
}
img {
  border: 0;
  vertical-align: middle;
}
ul,
li {
  list-style: none;
}
a {
  text-decoration: none;
  cursor: pointer;
}
/*清除浮动*/
.clear-both:before,
.clear-both:after {
  display: table;
  content: "";
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  clear: both;
}
.clearfix {
  *zoom: 1; /*IE/7/6*/
}
.fl {
  float: left;
}
.fr {
  float: right;
}

/*header_开始*/
.image_{
	 margin-top:5px;
	 width: 99%;
	 margin-left: 0.5%;
	 height:285px;
	 background-size:cover;
}
.header_ {
  width: 100%;
  height: 50px;
  padding: 0px;
  min-width:500px;
}
.bg_header_ {
  width: 100%;
  height: 40px;
  background: url("../../../../static/title.png") no-repeat;
  background-size: 100% 100%;
}
.header_ > .header__logo {
  padding: 18px 10px 10px 0px;
}
.header_ > .header__logo > a {
  display: block;
}
.header_ > .header__logo > a > img {
  width: 260px;
}

.header_ > .header__nav {
  margin-left: 20px;
}
.header_ > .header__nav > ul > li {
  float: left;
  margin-right: 6px;
  position: relative;
}
.header_ > .header__nav > ul > li > a {
  display: block;
  height: 40px;
  padding: 0 10px 0 30px;
  line-height: 40px;
  color: #fff;
}
.header_ > .header__nav > ul > li > a:hover {
  border-bottom: 4px solid #4b8df8;
}
.header_ > .header__nav > ul > li > img {
  float: left;
  position: absolute;
  top: 33px;
  left: 10px;
}
.header_ > .header__nav > ul > li > a.nav_current {
  border-bottom: 4px solid #4b8df8;
}

.header_ > .header__myself {
  width: 90px;
  text-align: center;
}
.header_ > .header__myself > p {
  color: #fff;
  font-size: 13px;
  margin-top: 15px;
}
.header_ > .header__myself > a {
  color: #fff;
  font-size: 13px;
}
.t_title_ {
  width: 100%;
  height: 100%;
  text-align: center;
  font-size:1.6em;
  line-height:35px;
  color: #fff;
}
#chart_map {
  cursor: pointer;
}
.t_show {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 2px;
  background: #2c58a6;
  padding: 2px 5px;
  color: #fff;
  cursor: pointer;
}
/*content 开始*/
.data_content_ {
  /*overflow-x: hidden;*/
  min-width: 500px;
 
  padding-bottom: 0px;
}
.data_content_ .data_time {
  width: 340px;
  height: 10px;
  /*background-color: #2C58A6;*/
  /*  line-height: 20px;
    color: #fff;*/
  font-size: 12.8px;
  position: relative;
 
  margin-left: 20px;
  text-align: center;
}
.data_content_ .data_time img {
  position: absolute;
  top: 8px;
  left: 15px;
}
.data_content_ .data_info {
  width: calc(100% - 40px);
  margin-bottom: 40px;
  height: 110px;
  margin-left: 20px;
}
.data_content_ .data_info .info_1 {
  width: 40%;
  height: 110px;
}
.data_content_ .data_info .info_1 > .text_1 {
  width: calc(100% - 25px);
  background-color: #034c6a;
  height: 110px;
}

.data_content_ .data_info .info_2 {
  width: 31%;
  height: 110px;
}
.data_content_ .data_info .info_2 > .text_2 {
  width: calc(100% - 25px);
  background-color: #034c6a;
  height: 110px;
}

.data_content_ .data_info .info_3 {
  width: 29%;
  height: 110px;
}
.data_content_ .data_info .info_3 > .text_3 {
  width: 100%;
  background-color: #034c6a;
  height: 110px;
}

.data_content_ .data_info > div.info_1 > .text_1 > div {
  width: 33.333%;
  position: relative;
}
.data_content_ .data_info > div.info_2 > div > div,
.data_content_ .data_info > div.info_3 > div > div {
  width: 50%;
  position: relative;
}
.data_content_ .data_info img {
  position: absolute;
  top: 35px;
  left: 15px;
}
.data_content_ .data_info > div > div > div > div {
  margin-left: 65px;
  margin-top: 23px;
}
.data_content_ .data_info > div.info_2 > div > div > div {
  margin-left: 70px;
  margin-top: 23px;
}
.data_content_ .data_info p:nth-child(1) {
  color: #fff;
  font-size: 12.8px;
}
.data_content_ .data_info p:nth-child(2) {
  font-weight: 600;
  font-size: 28px;
  color: #ffff43;
}
.data_content_ .data_info > div.info_2 p:nth-child(2) {
  font-weight: 600;
  font-size: 28px;
  color: #25f3e6;
}
.data_content_ .data_info > div.info_3 p:nth-child(2) {
  font-weight: 600;
  font-size: 28px;
  color: #ff4e4e;
}

.data_content_ .data_main {
  width: calc(100% - 40px);
  margin-bottom: 10px;
  height:290px;
  margin-left: 20px;
}
.data_content_ .data_main .main_left {
  width: 24%;
}
.data_content_ .data_main .main_left > div {
  width: 100%;
  height: 290px;
  box-sizing: border-box;
  border: 1px solid #2c58a6;
  position: relative;
  box-shadow: 0 0 10px #2c58a6;
}
.data_content_ .data_main .main_left div.left_1 {
  /*background: url("../img/chart_1.png") no-repeat center;*/
}

.data_content_ .data_main .main_left div.left_2 {
  /*background: url("../img/chart_2.png") no-repeat center;*/
}
.data_content_ .data_main .main_left div:nth-child(1) {
  margin-bottom: 10px;
}
.data_content_ .data_main .main_left div .main_title {
  width: 150px;
  height: 30px;
  line-height: 30px;
  background-color: #2c58a6;
  border-radius: 5px;
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -90px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  box-sizing: border-box;
  padding-left: 35px;
  z-index: 1000;
}

.data_content_ .data_main .main_left div .main_title img {
  position: absolute;
  top: 8px;
  left: 20px;
}

.data_content_ .data_main .main_center {
  width: 50%;
  height:290px;
}
.data_content_ .data_main .main_center .center_text {
  width: calc(100% - 10px);
  height:290px;
  
  box-sizing: border-box;
  border: 1px solid #2c58a6;
  box-shadow: 0px 0px 6px #2c58a6;
  position: relative;
}
.l_t_line {
  width: 5px;
  height: 24px;
  left: -3px;
  top: -3px;
}
.t_l_line {
  height: 5px;
  width: 26px;
  left: -3px;
  top: -3px;
}
.t_line_box {
  position: absolute;
  width: 100%;
  height: 100%;
}
.t_line_box i {
  background-color: #4788fb !important;
  box-shadow: 0px 0px 10px #4788fb  !important;;
  position: absolute  !important;;
}
.t_r_line {
  height: 5px ;
  width: 26px;
  right: -3px;
  top: -3px;
}
.r_t_line {
  width: 5px;
  height: 24px;
  right: -3px;
  top: -3px;
}
.l_b_line {
  width: 5px;
  height: 24px;
  left: -3px;
  bottom: -3px;
}
.b_l_line {
  height: 5px;
  width: 26px;
  left: -3px;
  bottom: -3px;
}
.r_b_line {
  width: 5px  !important;;
  height: 24px  !important;;
  right: -3px  !important;;
  bottom: -3px  !important;;
}
.b_r_line {
  height: 5px;
  width: 26px;
  right: -3px;
  bottom: -3px;
}
.data_content_ .data_main .main_center .main_title {
 width: 150px;
 height: 30px;
 line-height: 30px;
 background-color: #2c58a6;
 border-radius: 5px;
 position: absolute;
 top: -10px;
 left: 50%;
 margin-left: -90px;
 color: #fff;
 font-size: 14px;
 font-weight: 300;
 box-sizing: border-box;
 padding-left: 35px;
 z-index: 1000;
}
.data_content_ .data_main .main_center .main_title img {
  position: absolute;
  top: 8px;
  left: 20px;
}

.data_content_ .data_main .main_right {
  width:50%;
}
.data_content_ .data_main .main_right > div {
  width: 100%;
  height: 200px;
  box-sizing: border-box;
  border: 1px solid #2c58a6;
  position: relative;
  box-shadow: 0 0 10px #2c58a6;
}
.data_content_ .data_main .main_right div.right_1 .choice {
  position: absolute;
  top: 25px;
  right: 30px;
  z-index: 1000;
}
.data_content_ .data_main .main_right div.right_1 .choice label {
  color: #fff;
}

.data_content_ .data_main .main_right div.right_2 {
  /*background: url("../img/chart_4.png") no-repeat center;*/
}
.data_content_ .data_main .main_right div.right_2 .chart_text {
  width: 18%;
  color: #fff;
  text-align: center;
  margin-top: 12px;
}
.data_content_ .data_main .main_right div.right_2 .chart_text p {
  margin-top: 21px;
}
.data_content_ .data_main .main_right div.right_2 .chart_text p img {
  margin-right: 5px;
  margin-top: -4px;
}
.data_content_ .data_main .main_right div.right_2 .chart_text p:nth-child(1) {
  font-size: 14px;
  font-weight: 600;
}
.data_content_ .data_main .main_right div.right_2 .text_sum {
  text-align: center;
  color: #ffff43;
  font-weight: 600;
}
.data_content_ .data_main .main_right div.right_2 .text_sum div:nth-child(2) {
  font-size: 18px;
  font-weight: 600;
}
.data_content_ .data_main .main_right div:nth-child(1) {
  margin-bottom: 8px;
}
.data_content_ .data_main .main_right div .main_title {
  width: 150px;
  height: 30px;
  line-height: 30px;
  background-color: #2c58a6;
  border-radius: 5px;
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -90px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  box-sizing: border-box;
  padding-left: 35px;
  z-index: 1000;
}
.data_content_ .data_main .main_right div .main_title img {
  position: absolute;
  top: 8px;
  left: 20px;
}

.data_content_ .data_bottom_ {
  width: calc(100% - 40px);
  height:200px;
  margin-left: 20px;
}
.data_content_ .data_bottom_ div {
}
.data_content_ .data_bottom_ .bottom_1 {
  width: 100%;
 
  position: relative;
  box-sizing: border-box;
  border: 1px solid #2c58a6;
  box-shadow: 0 0 10px #2c58a6;
}
.data_content_ .data_bottom_ .bottom_center {
  width: 52%;
  height: 255px;
}
.data_content_ .data_bottom_ .bottom_2 {
	width: 100%;
	position: relative;
	box-sizing: border-box;
	border: 1px solid #2c58a6;
	box-shadow: 0 0 10px #2c58a6;
}
.data_content_ .data_bottom_ .bottom_3 {}
.data_content_ .data_bottom_ .bottom_4 {}
.data_content_ .data_bottom_ div .main_title {
  width: 100px;
  height:28px;
  line-height: 28px;
  background-color: transparent;
  border-radius: 5px;
  position: absolute;
  top: -2px;
  left: 50%;
  margin-left: -59px;
  color: #fff;
  font-size: 14px;
  font-weight: 300;
  box-sizing: border-box;
  border:1px solid #3E999F;
  padding-left: 50px;
  z-index: 1000;
}
.data_content_ .data_bottom_ div .main_title img {
  position: absolute;
  top: 8px;
  left: 20px;
}

.data_content_ .data_bottom_ div .main_table tr {
  height: 42px;
}
.data_content_ .data_bottom_ div .main_table {
  width: 100%;
  margin-top: 10px;
}
.data_content_ .data_bottom_ div .main_table table {
  width: 100%;
}
.data_content_ .data_bottom_ div .main_table thead tr {
  height: 42px;
}
.data_content_ .data_bottom_ div .main_table th {
  font-size: 12px;
  font-weight: 600;
  color: #61d2f7;
  text-align: center;
}
.data_content_ .data_bottom_ div .main_table th:nth-child(1) {
	
}
.data_content_ .data_bottom_ div .main_table th:nth-child(2) {
}
.data_content_ .data_bottom_ div .main_table td {
  color: #fff;
  font-size: 10px;
  text-align: center;
}
.data_content_ .data_bottom_ div .main_table tbody tr:nth-child(1),
.data_content_ .data_bottom_ div .main_table tbody tr:nth-child(3),
.data_content_ .data_bottom_ div .main_table tbody tr:nth-child(5) {

}

#main_table_ tr {
  height: 30px;
}
#main_table_ {
  width: 100%;
  margin-top: 5px;
}
#main_table_   table {
  width: 100%;
}
#main_table_  thead tr {
  height: 30px;
}
#main_table_  th {
  font-size: 13px;
  font-weight: 600;
  color: #61d2f7;
  text-align: center;
}


#main_table_  td {
  color: #fff;
  font-size:14px;
  text-align: center;
}

#main_table_  tbody tr:nth-child(1),
#main_table_  tbody tr:nth-child(2),
#main_table_  tbody tr:nth-child(4),
#main_table_ tbody tr:nth-child(3),
#main_table_ tbody tr:nth-child(5) {


}

/deep/ .el-table tbody tr:hover>td {
            background-color:#0c1e32 !important
        }
#main_table_ #datatxet_centaz .el-table--border::after, .el-table--group::after, .el-table::before{
     	   background-color: transparent;
     }
   /deep/   .el-table__body-wrapper {
	   border-bottom: #0c1e32;
	   
   }
.t_btn8,
.t_btn2,
.t_btn3 {
  position: relative;
  z-index: 100;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/system/index/data/dataAnalysis.vue